import React, { useState, useEffect } from "react";
// import '../../Accounts/Accounts.css';
import { Modal, Form } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { submitRenewalRequest } from "../../../../store/features/actions/renewalAgentActions";
import CircularLoader from "../../../HtmlElements/CircularLoader";

const RenewalNoteModal = ({ show, onClose, clientName, accountName, contacts = [], companies = [], spotContactsLoading }) => {
    const dispatch = useDispatch();
    const { loading, errorMessage } = useSelector(state => state.renewalReducer);
    const [contact, setContact] = useState("");
    const [company, setCompany] = useState("");
    const [contactError, setContactError] = useState("");
    const [companyError, setCompanyError] = useState("");

    const handleSubmit = (e) => {
      e.preventDefault();
      let isValid = true;
  
      if (!contact) {
        setContactError("Contact is required.");
        isValid = false;
      } else {
        setContactError("");
      }
  
      if (!company) {
        setCompanyError("Live Company is required.");
        isValid = false;
      } else {
        setCompanyError("");
      }
  
      if (!isValid) return;
  
      dispatch(submitRenewalRequest({
        clientName,
        accountName,
        contact,
        account_id: company,
        response_type: "pdf"
      }));
  
      setContact("");
      setCompany("");
      setContactError("");
      setCompanyError("");
      onClose();
    };
  
    const companyOptions = companies.map((company) => ({
      value: company.id,
      label: company.company_name
    }));
  
    return (
      loading ? (
        <div
          // style={{ textAlign: 'center', marginTop: '50px' }}
          style={{
            position: 'fixed',
            paddingTop: '80px',
            top: '16px',
            right: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '12px',
            zIndex: 9999,
            pointerEvents: 'none', // so background stays clickable
          }}
        >
          <CircularLoader />
        </div>) : (<Modal size="lg" show={show} onHide={onClose} centered>
        <Modal.Body>
          <div className="recent_dev_wrapper">
            <div className="recent_dev_block">
              <div className="recent_icon_head">
                <div className="recent_head_block">
                  <h3 className="recent_head">Renewal Note</h3>
                </div>
                <Modal.Header closeButton style={{ borderBottom: 0 }} />
              </div>
              <div className="para_block">
                <Form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-3 custom_agentform_group">
                        <Form.Label className="custom_agentform_label">
                          Select Contact <span className='red'>*</span>
                          {/* {spotContactsLoading && <i className="fa fa-spinner fa-spin"></i> } */}
                        </Form.Label>
                        <Form.Select
                          className="custom_agentform_control"
                          value={contact}
                          disabled={loading}
                          onChange={(e) => {
                            const value = e.target.value;
                            setContact(value);
                            setContactError(value === "" ? "Contact is required" : "");
                          }}
                        >
                          {spotContactsLoading ? (<option> Loading... </option>) : (
                           <>
                            <option value="">Select Contact</option>
                            {contacts.map((c, index) => (
                              <option key={index} value={c.name}>
                                {c.name}
                              </option>
                            ))}
                           </> 
                          )}
                          
                        </Form.Select>
                        {contactError && <p className="text-danger">{contactError}</p>}
                      </Form.Group>
                    </div>
                  </div>
  
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-3 custom_agentform_group">
                        <Form.Label className="custom_agentform_label">Select Company</Form.Label>
                        <Select
                          className="custom_agentform_control"
                          options={companyOptions}
                          value={company ? companyOptions.find((opt) => opt.value === company) : null}
                          isDisabled={loading}
                          onChange={(selectedOption) => {
                            const value = selectedOption ? selectedOption.value : "";
                            setCompany(value);
                            setCompanyError(value === "" ? "Company selection is required" : "");
                          }}
                          placeholder="Select Company"
                        />
                        {companyError && <p className="text-danger">{companyError}</p>}
                      </Form.Group>
                    </div>
                  </div>
  
                  <div className="col-md-12">
                    <div className="prev_next_block">
                      <button
                        type="submit"
                        className="genrate_modal_btn btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Generate"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary cancel_modal_btn ml-2"
                        disabled={loading}
                        onClick={() => {
                          setContact("");
                          setCompany("");
                          setContactError("");
                          setCompanyError("");
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                  {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>)
    );
  };
  
  export default RenewalNoteModal;  